import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { QueryKeys } from "@/constants";
import { fetchIDCard } from "@/services/id-card-service";
import type { IDCardPayload } from "@/types";
import type { IDCardResponseType } from "@/model/id-card";
import useUserInfo from "./use-user-info";
import type { PlanCoverageInfo } from "@/model/demographics";

const useIDCardQuery = (
  activeCoverage: PlanCoverageInfo,
): UseQueryResult<IDCardResponseType, Error> => {
  const userInfo = useUserInfo();
  const idCardPayload: IDCardPayload = {
    divisionId: userInfo.divisionId,
    employeeId: userInfo.employeeId,
    groupId: userInfo.groupId,
    loginGroupId: userInfo.loginGroupId,
    memberId: userInfo.memberId,
    planId: activeCoverage.planId ?? userInfo?.planId,
    encrypt: false,
    token: userInfo.accessToken,
    claimCoverageCode: activeCoverage.claimCoverageCode,
  };
  return useQuery({
    queryKey: [QueryKeys.ID_CARD, activeCoverage.claimCoverageCode],
    queryFn: async () => {
      const response = await fetchIDCard(idCardPayload);
      return response;
    },
    staleTime: Infinity,
  });
};

export { useIDCardQuery };
